import { useEffect, useRef, useState } from 'react'

export function useRevealClass() {
  const ref = useRef(null)
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const el = ref.current
    if (!el) return undefined

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return
        const siblings = Array.from(
          entry.target.parentElement?.querySelectorAll('.reveal, .reveal-left, .reveal-right') || [],
        )
        const i = siblings.indexOf(entry.target)
        const delay = Math.max(i, 0) * 80
        window.setTimeout(() => setVisible(true), delay)
        observer.unobserve(entry.target)
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' },
    )
    observer.observe(el)
    return () => observer.disconnect()
  }, [])

  return { ref, visible }
}
